import React from "react";

import { GameInterface } from "../components/GameInterface";
import { AppHeader } from "../components/AppHeader";
import { GameStart } from "../components/GameStart";
import { useApp } from "../contexts/app";

import hiveImage from "../style/pictures/6.jpg";
import woodTexture from "../style/pictures/7.jpg";

const backgroundStyle = (onGoingGame: boolean): React.CSSProperties => ({
  backgroundImage: `url(${onGoingGame ? woodTexture : hiveImage})`,
  backgroundSize: "cover",
  backgroundPositionX: "center",
  backgroundPositionY: "top",
  zIndex: -1,
});

export const Home = () => {
  const {
    state: { onGoingGame },
  } = useApp();

  return (
    <div className="fullheight">
      <AppHeader />

      <div className="fullheight">
        {!onGoingGame && (
          <div
            className="position-absolute bg-light h-100 w-100"
            style={backgroundStyle(onGoingGame)}
          />
        )}

        <div className="fullheight app-container">
          {onGoingGame ? <GameInterface /> : <GameStart />}
        </div>
      </div>
    </div>
  );
};
